const state = {
  user: null, //current users data
  lastUpdated: Date.now(),

  // permissions
  isGuest: false, //external guest or space guest (not area member but registered)
  isExternalGuest: false, //full guest, not registered
};

const getters = {
	data: () => state.user,
  lastUpdated: (state) => state.lastUpdated || '',

  id: (state) => state.user?.id || '',
  email: (state) => state.user?.email || '',
  firstName: (state) => state.user?.firstName || '',
  lastName: (state) => state.user?.lastName || '',
  fullName: (state) => `${state.user?.firstName} ${state.user?.lastName}`.trim(),
  avatar: (state, getters, rootState, rootGetters) => rootGetters['api/media/origin'] + `/i/profile/${getters.id}.jpg?blah=${getters.lastUpdated}`,
  field1: (state) => state.user?.field1 || '',
  field2: (state) => state.user?.field2 || '',
  status: (state, getters, rootState, rootGetters) => {
    if(['home', 'create-area'].includes(rootGetters['routing/routeName'])) return 'offline'
    else return rootGetters.getIfCurrentUsersRoomIsHub ? 'available' : 'in-meeting'
  },
  createdAt: (state) => state.user?.createdAt || '',
  showTour: (state) => state.user?.showTour || false,
  pronouns: (state) => state.user?.pronouns || '',
  linkedInUrl: (state) => state.user?.linkedInProfileUrl || '',

  // user areas and permissions ----------------------
  currentAreaPermissionNo(state, getters) {
    return getters.isAreaAdmin ? 1 : 0;
  },
  isAreaAdmin(state, getters, rootState, rootGetters) {
    return rootGetters.getCurrentAreaData?.isSpaceAdmin;
  },

  // permissions
  isGuest: (state) => state.isGuest || state.isExternalGuest,
  isExternalGuest: (state) => state.isExternalGuest
}

const mutations = {
  USER: (state, user) => {
    if(state.user?.id && user !== null) {
      state.user = Object.assign(state.user, user);
    }
    else state.user = user
    state.lastUpdated = Date.now()
  },

  // permissions
  GUEST: (state, value) => state.isGuest = value,
  EXTERNAL_GUEST: (state, value) => state.isExternalGuest = value
}

const actions = {
  async fetchUser({ commit, dispatch }) {
    let res = await dispatch('api/users/getMe', null, {root: true});
    if(res.success) {
      commit('USER', res.success);
    }
    else throw new Error("Getting user details failed");
  },
  async updateGuestState({commit, dispatch}, data) {
    commit('GUEST', data.isGuest)
    dispatch('setExternalGuest', data.isExternalGuest)
  },
  setExternalGuest({commit}, isExternalGuest) {
    commit('EXTERNAL_GUEST', isExternalGuest)
  },
  async clearGuestState({commit, dispatch}) {
    commit('GUEST', false)
    dispatch('setExternalGuest', false)
  },
}

export default {
	state,
  getters,
  mutations,
  actions
};
